import React from "react";
import Home from "../theme/default/Home";

// Every route below except Home is lazy-loaded. AppRoutes.js used to statically import all of
// these, which forced webpack to bundle them into the main chunk regardless of the React.lazy()
// wrapping declared for the same files in ServiceModule/Service.js's pathMap -- neutralizing that
// code-splitting and shipping the entire app's JS on first load. Dynamic import() of the same
// module path from both places is deduped by webpack/the browser's module cache, so this is safe
// to do independently of Service.js's pathMap.
const PubSecurityLayout = React.lazy(() => import("../components/modules/security/PubSecurityLayout"));
const Booking = React.lazy(() => import("../components/modules/booking/Booking"));
const Reschedule = React.lazy(() => import("../components/modules/booking/Reschedule"));
const ProviderList = React.lazy(() => import("../components/modules/provider/Providerlist"));
const ProviderDetail = React.lazy(() => import("../components/modules/provider/ProviderDetail"));
const ProviderPublicProfile = React.lazy(() => import("../components/modules/provider/ProviderPublicProfile"));
const PrintLayout = React.lazy(() => import("../theme/Print/Layout"));
const DashBoardLayout = React.lazy(() => import("../components/modules/dashboard/DashboardLayout"));
const Reason = React.lazy(() => import("../components/modules/reason/Reason"));
const ScheduleConfirmation = React.lazy(() => import("../components/modules/consultation/summary/ScheduleConfirmation"));
const Pharmacy = React.lazy(() => import("../components/modules/pharmacy/pharmacy"));
const Payment = React.lazy(() => import("../components/modules/payments/payment"));
const MessageHome = React.lazy(() => import("../components/modules/message/home"));
const AddProfile = React.lazy(() => import("../components/modules/patient/AddProfile"));
const ProofUpload = React.lazy(() => import("../components/modules/patient/ProofUpload"));
const VitalAdd = React.lazy(() => import("../components/modules/consultation/vital/vitalAdd"));
const PaymentProcess = React.lazy(() => import("../components/modules/payments/PaymentProcees"));
const PaymentFailed = React.lazy(() => import("../components/modules/payments/PaymentFail"));
const ProcessPayment = React.lazy(() => import("../components/modules/payments/ProcessPayment"));
const ResidingState = React.lazy(() => import("../components/modules/patient/ResidingState"));
const PageNotFound = React.lazy(() => import("../services/utils/PageNotFound"));
const PatientDocument = React.lazy(() => import("../components/modules/patient/patientDocument"));
const VitalsForms = React.lazy(() => import("../components/modules/consultation/vital/VitalsForms"));
const Specialty = React.lazy(() => import("../components/modules/speciality/Specialty"));
const IntakeForms = React.lazy(() => import("../components/modules/consultation/form/FormLevel/IntakeForm"));
const MedicationConsent = React.lazy(() => import("../components/modules/consultation/MedicationConsent"));
const ClientLogout = React.lazy(() => import("../components/modules/security/ClientLogout"));
const PatientInsurance = React.lazy(() => import("../components/modules/patient/PatientInsurance"));
const EncounterInsurance = React.lazy(() => import("../components/modules/consultation/EncounterInsurance"));
const PatientForms = React.lazy(() => import("../components/modules/consultation/form/FormLevel/PatientForms"));
const DocumentsViewer = React.lazy(() => import("../components/modules/Documents/DocumentsViewer"));
const EncounterSummary = React.lazy(() => import("../components/modules/consultation/summary/EncounterSummary"));
const FamilyMember = React.lazy(() => import("../components/modules/patient/FamilyMember/FamilyMember"));
const SelectFamilyMember = React.lazy(() => import("../components/modules/patient/FamilyMember/SelectFamilyMember"));
const MemberPlanDetail = React.lazy(() => import("../components/modules/MemberPlan/MemberPlanDetail"));
const ExternalOrderCreate = React.lazy(() => import("../components/modules/consultation/ExternalorderCreate"));
const Consultation = React.lazy(() => import("../components/modules/consultation/consultation"));
const DirectForm = React.lazy(() => import("../components/modules/consultation/form/FormLevel/DirectForm"));
const ExternalForm = React.lazy(() => import("../components/modules/consultation/form/FormLevel/ExternalForm"));
const AppointmentMethods = React.lazy(() => import("../components/modules/dashboard/AppointmentMethod"));
const IntakeAllergy = React.lazy(() => import("../components/modules/consultation/Allergy/IntakeALlergy"));
const IntakeMedication = React.lazy(() => import("../components/modules/Medication/IntakeMedication"));
const AreYouHuman = React.lazy(() => import("../components/modules/security/AreYouHuman"));
const IntakeRefillMedication = React.lazy(() => import("../components/modules/RefillMedication/IntakeRefillMedication"));
const Service = React.lazy(() => import("../components/ServiceModule/Service"));
const ServiceList = React.lazy(() => import("../components/ServiceModule/ServiceList"));
const TermsAndCondition = React.lazy(() => import("../components/modules/security/TermsFooter"));
const PrivacyPolicy = React.lazy(() => import("../components/modules/security/PrivacyPolicyFooter"));
const SelfEnrollment = React.lazy(() => import("../components/modules/enroll/SelfEnrollment"));
const EnrollmentPaymentProcess = React.lazy(() => import("../components/modules/enroll/EnrollPaymentProcess"));
const CancellationPolicy = React.lazy(() => import("../components/modules/payments/CancellationPolicy"));
const SubscriptionTermsandconditions = React.lazy(() => import("../components/modules/payments/SubscriptionTerms"));
const FinancialPolicy = React.lazy(() => import("../components/modules/payments/FinancialPolicy"));
const Logout = React.lazy(() => import("../components/modules/security/Logout"));
const PaymentForm = React.lazy(() => import("../components/modules/payments/PaymentGateway"));
const LabOrder = React.lazy(() => import("../components/modules/Lab/LabOrder"));
const LabSearch = React.lazy(() => import("../components/modules/Lab/LabSearch"));
const LabResidingState = React.lazy(() => import("../components/modules/Lab/LabResidingState"));
const PreConsultationForm = React.lazy(() => import("../components/modules/consultation/form/FormLevel/PreConsultationForm"));
const Index = React.lazy(() => import("../components/modules/session/Index"));
const SearchDiagnostic = React.lazy(() => import("../components/modules/Lab/SearchDiagnostic"));
const LabPayment = React.lazy(() => import("../components/modules/Lab/LabPayment"));
const LabPaymentProcess = React.lazy(() => import("../components/modules/Lab/LabPaymentProcess"));
const LabOrderConfirmation = React.lazy(() => import("../components/modules/Lab/LabOrderConfirmation"));
const LabOrderFailed = React.lazy(() => import("../components/modules/Lab/LabOrderFailed"));
const SSO = React.lazy(() => import("../components/modules/security/entry/SSO"));
const Ext = React.lazy(() => import("../components/modules/security/entry/Ext"));
const AnemoCheckAssessment = React.lazy(() => import("../components/modules/anemocheck/AnemoCheckAssessment"));
const UpdatePaymentForm = React.lazy(() => import("../components/modules/payments/UpdatePayment"));

const AppRoutes = [
    {
        index: true,
        element: <Home />,
    },
    {
        path: "/security/login",
        element: <PubSecurityLayout body="login" />,
    },
    {
        path: "/security/signup",
        element: <PubSecurityLayout body="signup" />,
    },
    {
        path: "/security/forgotpassword",
        element: <PubSecurityLayout body="forgotpassword" />,
    },
    {
        path: "/security/resetpassword",
        element: <PubSecurityLayout body="resetpassword" />,
    },
    {
        path: "/security/passwordsuccess",
        element: <PubSecurityLayout body="passwordsuccess" />,
    },
    {
        path: "/security/passwordfailed",
        element: <PubSecurityLayout body="passwordfailed" />,
    },
    {
        path: "/activateaccount",
        element: <PubSecurityLayout body="accountactivation" />,
    },
    {
        path: "/security/otpverification",
        element: <PubSecurityLayout body="otpverification" />,
    },
    {
        path: "/sso",
        element: <SSO />,
    },
    {
        path: "/link",
        element: <Ext />, // I Cant name it Link because of the error "Link is used for router dom", I have to name it Ext
    },
    {
        path: "/security/logout",
        element: <Logout />,
    },
    {
        path: "/insurance",
        element: <PatientInsurance />,
    },
    {
        path: "/alldocuments",
        element: <PatientDocument />,
    },
    {
        path: "/payment/insurance",
        element: <EncounterInsurance />,
    },
    {
        path: "/vitals",
        element: <VitalAdd />,
    },
    {
        path: "/confirmation",
        element: <ScheduleConfirmation />,
    },
    {
        path: "/dashboard",
        element: <DashBoardLayout body="dashboard" />,
    },
    {
        path: "/profile",
        element: <DashBoardLayout body="profile" />,
    },
    {
        path: "/residingstate",
        element: <ResidingState />,
    },
    {
        path: "/idverification/upload",
        element: <ProofUpload />,
    },
    {
        path: "/addprofile",
        element: <AddProfile />,
    },
    {
        path: "/changepassword",
        element: <DashBoardLayout body="changepassword" />,
    },
    {
        path: "/visit/detail",
        element: <DashBoardLayout body="detailpage" />,
    },
    {
        path: "/specialty",
        element: <Specialty />,
    },
    {
        path: "/provider",
        element: <ProviderList />,
    },
    {
        path: "/providerprofile",
        element: <ProviderPublicProfile />,
    },
    {
        path: "/booking",
        element: <Booking />,
    },
    {
        path: "/reschedule",
        element: <Reschedule />,
    },
    {
        path: "/reason",
        element: <Reason />,
    },
    {
        path: "/profiledetail",
        element: <ProviderDetail />,
    },
    {
        path: "/pharmacy",
        element: <Pharmacy />,
    },
    {
        path: "/payment",
        element: <Payment />,
    },
    {
        path: "/paymentprocess",
        element: <PaymentProcess />,
    },
    {
        path: "/processPayment",
        element: <ProcessPayment />,
    },
    {
        path: "/payment/fail",
        element: <PaymentFailed />,
    },
    {
        path: "/message",
        element: <MessageHome />,
    },
    {
        path: "/printpage",
        element: <PrintLayout />,
    },
    {
        path: "/vital/add",
        element: <VitalsForms />,
    },
    {
        path: "/intakeforms",
        element: <IntakeForms />,
    },
    {
        path: "/financial-policy",
        element: <FinancialPolicy />,
    },
    {
        path: "/forms",
        element: <PatientForms />,
    },
    {
        path: "/form",
        element: <DirectForm />,
    },
    {
        path: "/form/anemocheck",
        element: <AnemoCheckAssessment />,
    },
    {
        path: "/preconsultationform",
        element: <PreConsultationForm />,
    },
    {
        path: "/docviewer",
        element: <DocumentsViewer />,
    },
    {
        path: "/test/viewer",
        element: <DocumentsViewer />,
    },
    {
        path: "/medication-consent",
        element: <MedicationConsent />,
    },
    {
        path: "/appointment/summary",
        element: <EncounterSummary />,
    },
    {
        path: "/familymember",
        element: <FamilyMember />,
    },
    {
        path: "/selectfamilymember",
        element: <SelectFamilyMember />,
    },
    {
        path: "/plan/detail",
        element: <MemberPlanDetail />,
    },
    {
        path: "/consultation",
        element: <Consultation />,
    },
    {
        path: "/security/ssologout",
        element: <ClientLogout />,
    },
    {
        path: "/externalorder/create",
        element: <ExternalOrderCreate />,
    },
    {
        path: "/externalforms",
        element: <ExternalForm />,
    },
    {
        path: "/consultation/select",
        element: <AppointmentMethods />,
    },
    {
        path: "/allergy-add",
        element: <IntakeAllergy />,
    },
    {
        path: "/medication",
        element: <IntakeMedication />,
    },
    {
        path: "/delete-data",
        element: <PubSecurityLayout body="deletedata" />,
    },
    {
        path: "/terms",
        element: <TermsAndCondition name="TermsAndCondition" />,
    },
    {
        path: "/privacy",
        element: <PrivacyPolicy name="PrivacyPolicy" />,
    },
    {
        path: "/page-access-denied",
        element: <PageNotFound name="Aceess" />,
    },
    {
        path: "/pagenotfound",
        element: <PageNotFound name="NotFound" />,
    },
    {
        path: "/discard",
        element: <PageNotFound name="discard" />,
    },
    {
        path: "/security/are-you-human",
        element: <AreYouHuman />,
    },
    {
        path: "/services",
        element: <ServiceList />,
    },
    {
        path: "/service",
        element: <Service />,
    },
    {
        path: "/refillmedication",
        element: <IntakeRefillMedication />,
    },
    {
        path: "/enroll",
        element: <SelfEnrollment />,
    },
    {
        path: "/enroll",
        element: <SelfEnrollment />,
    },
    {
        path: "/successenroll",
        element: <SelfEnrollment type="success" />,
    },
    {
        path: "/enrollfailed",
        element: <SelfEnrollment type="failed" />,
    },
    {
        path: "/enrollpaymentprocess",
        element: <EnrollmentPaymentProcess />,
    },
    {
        path: "/cancellationpolicy",
        element: <CancellationPolicy />,
    },
    {
        path: "/subscriptiontc",
        element: <SubscriptionTermsandconditions />,
    },
    {
        path: "/financial-policy",
        element: <FinancialPolicy />,
    },
    {
        path: "/paymentgateway",
        element: <PaymentForm type="enrollment" />,
    },
    {
        path: "/updatepayment",
        element: <UpdatePaymentForm />,
    },
    {
        path: "/orderlab",
        element: <LabOrder />,
    },
    {
        path: "/lablocation",
        element: <LabResidingState />,
    },
    {
        path: "/labsearch",
        element: <LabSearch />,
    },
    {
        path: "/searchdiagnostic",
        element: <SearchDiagnostic />,
    },
    {
        path: "/labpayment",
        element: <LabPayment />,
    },
    {
        path: "/labpaymentprocess",
        element: <LabPaymentProcess />,
    },
    {
        path: "/labconfirmation",
        element: <LabOrderConfirmation />,
    },
    {
        path: "/labfailed",
        element: <LabOrderFailed />,
    },
    {
        path: "/session",
        element: <Index />,
    },
    {
        path: "*",
        element: <PageNotFound />,
    },
    {
        path: "/labresume",
        element: <LabOrder isResume={true} />,
    },
];

export default AppRoutes;
